import { render, staticRenderFns } from "./WatchersRenderer.vue?vue&type=template&id=77404299&scoped=true&"
import script from "./WatchersRenderer.vue?vue&type=script&lang=js&"
export * from "./WatchersRenderer.vue?vue&type=script&lang=js&"
import style0 from "./WatchersRenderer.vue?vue&type=style&index=0&id=77404299&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77404299",
  null
  
)

/* custom blocks */
import block0 from "./WatchersRenderer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports